import { LinkTag } from './link-tag';
import { BucketS3Env } from '@qaroni-core/config/bucket-s3/bucket-s3.config';

export const LINKTAGSARRAY: LinkTag[] = [
  {
    rel: 'shortcut icon',
    href: `${BucketS3Env.baseUrl}/favicon/favicon.ico`,
    type: 'image/x-icon',
  },
  {
    rel: 'apple-touch-icon',
    sizes: '57x57',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-57x57.png`,
  },
  {
    rel: 'apple-touch-icon',
    sizes: '60x60',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-60x60.png`,
  },
  {
    rel: 'apple-touch-icon',
    sizes: '72x72',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-72x72.png`,
  },
  {
    rel: 'apple-touch-icon',
    sizes: '76x76',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-76x76.png`,
  },
  {
    rel: 'apple-touch-icon',
    sizes: '114x114',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-114x114.png`,
  },
  {
    rel: 'apple-touch-icon',
    sizes: '120x120',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-120x120.png`,
  },
  {
    rel: 'apple-touch-icon',
    sizes: '144x144',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-144x144.png`,
  },
  {
    rel: 'apple-touch-icon',
    sizes: '152x152',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-152x152.png`,
  },
  {
    rel: 'apple-touch-icon',
    sizes: '180x180',
    href: `${BucketS3Env.baseUrl}/favicon/apple-touch-icon-180x180.png`,
  },
  {
    rel: 'icon',
    type: 'image/png',
    href: `${BucketS3Env.baseUrl}/favicon/favicon-16x16.png`,
    sizes: '16x16',
  },
  {
    rel: 'icon',
    type: 'image/png',
    href: `${BucketS3Env.baseUrl}/favicon/favicon-32x32.png`,
    sizes: '32x32',
  },
  {
    rel: 'icon',
    type: 'image/png',
    href: `${BucketS3Env.baseUrl}/favicon/favicon-96x96.png`,
    sizes: '96x96',
  },
  {
    rel: 'icon',
    type: 'image/png',
    href: `${BucketS3Env.baseUrl}/favicon/android-chrome-192x192.png`,
    sizes: '192x192',
  },
  {
    rel: 'stylesheet',
    href: `https://fonts.googleapis.com/icon?family=Material+Icons`,
  },
];
